import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UIService {
  isMobile = new BehaviorSubject(false);

  setIsMobile(value: boolean) {
    this.isMobile.next(value);
  }
}
